import {v4 as uuidv4} from 'uuid';
import global_axios from "../../funciones_globales/interaccionapi";
import {VISUALIZAR_ALERTA, VISUALIZAR_LOADING} from "../generales/actionTypes";
import {
    CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA,
    ADD_CARTON,
    DELETE_CARTON,
    UPDATE_CARTON,
    UPDATE_COD_ULT_CARTON,
    UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR,
    DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA,
    RESET_ITEMS_A_ENCARTONAR,
    UPDATE_PESO_CARTON,
    UPDATE_FLAG_PESO_AUTOMATICO,
    CARGAR_PROFORMAS_A_ENCARTONAR,
    RESET_PROFORMAS_A_ENCARTONAR,
    UPDATE_ESTADO_PROFORMA_ENCARTONADA,
    CARGAR_ENCARTONADO,
    SET_ENCARTONADO_ID,
    SET_ENCARTONADO_OBSERVACION,
    SET_ENCARTONADO_FECHA
} from "./actionTypes";
import {SET_CLIENTE} from "../clientes/actionTypes";
import {generarItemCatalogoSeleccionado} from "../../funciones_globales/catalogos";
import moment from "moment";

export const cargarProformasAEncartonarPorCliente = (idCliente) => {
    return (dispatch) => {
        dispatch({
            type: VISUALIZAR_LOADING,
            isVisibleLoading: true
        });

        return global_axios({
            url: `/clientes/${idCliente}/proformas-por-encartonar`,
            method: 'GET'
        })
        .then(response => {
            let proformas = response.data;

            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            dispatch({
                type: CARGAR_PROFORMAS_A_ENCARTONAR,
                proformas: proformas.map(prof => ({ id: prof.Pedido,
                                                    pedidoMovil: prof.PedMovil,
                                                    idCliente: prof.cli.Codigo,
                                                    nombreCliente: prof.cli.Nombre,
                                                    tipo: prof.Tipo==='B'? 'STOCK': (prof.Tipo==='T'? 'TRÁNSITO':'DESCONOCIDO'),
                                                    esEncartonada: false}))
            });
        })
        .catch(error => {
            let msgError = error.response ? error.response.data.msg : error.message;
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });
            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'error',
                    titulo: 'Error al cargar proformas a encartonar',
                    mensaje: msgError
                }
            });
        });
    }
}

export const cambiarEstadoDeProformaEncartonada = (idProforma, esEncartonada) => {
    return {type: UPDATE_ESTADO_PROFORMA_ENCARTONADA, data: {idProforma, esEncartonada}};
}

export const resetProformasAEncartonar = () => {
    return {type: RESET_PROFORMAS_A_ENCARTONAR};
}

export const cargarItemsAEncartonarPorProforma = (idProforma, callback) => {
    return (dispatch) => {
        dispatch({
            type: VISUALIZAR_LOADING,
            isVisibleLoading: true
        });

        return global_axios({
            url: `/proformas/${idProforma}`,
            method: 'GET'
        })
        .then(response => {
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            let businessLogicError;
            const proforma = response.data;
            let itemsAEncartonarPorProforma = [];

            if(proforma === null) {
                businessLogicError = `La proforma ${idProforma} no existe.`;
            } else {
                const tiposDeProformaValidos = ['B', 'T'];
                itemsAEncartonarPorProforma = mapearItemsAEncartonarDesdeProforma(proforma);

                if (!tiposDeProformaValidos.includes(proforma.Tipo) || itemsAEncartonarPorProforma.length === 0 ) {
                    businessLogicError = `La proforma ${idProforma} no tiene items para despachar.`;
                }
            }

            if(businessLogicError) {
                dispatch({
                    type: VISUALIZAR_ALERTA,
                    data: {
                        isVisible: true,
                        tipo: 'error',
                        titulo: 'Error al cargar items a encartonar',
                        mensaje: businessLogicError
                    }
                });
            } else {
                dispatch({
                    type: CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA,
                    items: itemsAEncartonarPorProforma
                });

                if (callback && typeof(callback) === 'function') {
                    callback();
                }
            }
        })
        .catch(error => {
            let msgError = error.response ? error.response.data.msg : error.message;
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });
            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'error',
                    titulo: 'Error al cargar items a encartonar',
                    mensaje: msgError
                }
            });
        });
    }
}

const mapearItemsAEncartonarDesdeProforma = (proforma) => {
    return proforma.det_proforma
        .filter(item => item.Vendido > 0 && item.Articulo!=='EMBA')
        .map(item => {
            return {
                idItem: uuidv4(),
                pedMovil: proforma.Obra,
                proforma: proforma.Pedido,
                articulo: item.Articulo,
                nombreArtic: item.NombreArtic,
                cantidadDespacho: item.Vendido,
                ubicacion: item.Ubicacion,
                detalleCartones: [ {idCarton: uuidv4(), codCarton: '', cantidad: item.Vendido} ],
                erroresDeValidacion: []
            }
        });
}

export const eliminarItemsAEncartonarPorProforma = (idProforma) => {
    return {type: DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA, idProforma};
}

export const resetItemsAEncartonar = () => {
    return {type: RESET_ITEMS_A_ENCARTONAR };
}

export const agregarCarton = (idItem, carton) => {
    return {type: ADD_CARTON, data: {idItem, carton}};
}

export const eliminarCarton = (idItem, idCarton) => {
    return dispatch => {
        return new Promise((resolve) => {
            dispatch({
                type: DELETE_CARTON,
                data: {idItem, idCarton}
            });

            resolve();
        });
    }
}

export const actualizarCarton = (idItem, idCarton, updatedProp, updatedValue) => {
    return {type: UPDATE_CARTON, data: {idItem, idCarton, updatedProp, updatedValue}};
}

export const actualizarCodUltimoCarton = (ultimoCodCarton) => {
    return { type: UPDATE_COD_ULT_CARTON, ultimoCodCarton};
}

export const actualizarErroresDeValidacionDeItem = (idItem, erroresDeValidacion) => {
    return {type: UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR, data: {idItem, erroresDeValidacion}};
}

export const actualizarPesoDeCarton = (codCarton, peso) => {
    return {type: UPDATE_PESO_CARTON, data: {codCarton, peso}};
}

export const actualizarFlagPesoAutomatico = (codCarton, capturaAutomatica) => {
    return {type: UPDATE_FLAG_PESO_AUTOMATICO, data: {codCarton, capturaAutomatica}};
}

export const guardarEncartonado = (operacion, encartonado, callback) => {
    return (dispatch) => {
        dispatch({
            type: VISUALIZAR_LOADING,
            isVisibleLoading: true
        });

        return global_axios({
            url: operacion==='G'?'/encartonados':`/encartonados/${encartonado.id}`,
            method: operacion==='G'?'POST':'PUT',
            data: encartonado
        })
        .then(response => {
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'info',
                    titulo: 'Encartonado guardado',
                    mensaje: `Se guardó exitosamente el Encartonado: ${response.data.idEncartonado}`
                }
            });

            dispatch({
               type: SET_ENCARTONADO_ID,
               encartonadoId: response.data.idEncartonado
            });

            if (callback && typeof(callback) === 'function') {
                callback();
            }
        })
        .catch(error => {
            let msgError = error.response ? error.response.data.msg : error.message;
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });
            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'error',
                    titulo: 'Error al guardar el Encartonado',
                    mensaje: msgError
                }
            });
        });
    }
}

export const cargarEncartonado = (idEncartonado, callback) => {
    return (dispatch) => {
        dispatch({
            type: VISUALIZAR_LOADING,
            isVisibleLoading: true
        });

        return global_axios({
            url: `/encartonados/${idEncartonado}`,
            method: 'GET'
        })
        .then(response => {
            const encartonado = response.data;

            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            dispatch({
                type: CARGAR_ENCARTONADO,
                data: { itemsAEncartonar: mapearItemsAEncartonarDesdeEncartonado(encartonado),
                        resumenCartones: encartonado.detCarton.map(carton => ({codCarton: carton.CodCarton, unidades: carton.Unidades, peso: carton.Peso, capturaAutomatica: true})),
                        pesosDeCartones: new Map(encartonado.detCarton.map(carton => [carton.CodCarton, carton.Peso]))
                }
            });

            dispatch({
                type: SET_CLIENTE,
                data: generarItemCatalogoSeleccionado(encartonado.cli.Codigo, encartonado.cli.Nombre)
            });

            dispatch({
                type: SET_ENCARTONADO_OBSERVACION,
                observacion: encartonado.Observacion
            });

            dispatch({
                type: SET_ENCARTONADO_FECHA,
                fecha:  moment(encartonado.Fecha, 'DD/MM/YYYY'),
            });

            dispatch({
                type: CARGAR_PROFORMAS_A_ENCARTONAR,
                proformas: mapearProformasEncartonadasDesdeEncartonado(encartonado)
            });

            if (callback && typeof(callback) === 'function') {
                callback();
            }
        })
        .catch(error => {
            let msgError = error.response ? error.response.data.msg : error.message;
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'error',
                    titulo: 'Error al cargar el Encartonado',
                    mensaje: msgError
                }
            });
        });
    }
}

const mapearItemsAEncartonarDesdeEncartonado = (encartonado) => {
    return encartonado.detArt
        .map(item => {
            return {
                idItem: uuidv4(),
                pedMovil: item.PedidoMovil,
                proforma: item.prof.Proforma,
                articulo: item.art.Codigo,
                nombreArtic: item.art.Nombre,
                cantidadDespacho: item.CantDespacho,
                ubicacion: item.art.Ubicacion,
                detalleCartones: item.DetalleCartones.split('&').map(carton => ({idCarton: uuidv4(), codCarton: carton.split(':')[0], cantidad: carton.split(':')[1]})),
                erroresDeValidacion: []
            }
        });
}

const mapearProformasEncartonadasDesdeEncartonado = (encartonado) => {
    const proformasEncartonadas = encartonado.detArt.map(item => ({Proforma: item.prof.Proforma, TipoProf: item.prof.Tipo, PedidoMovil: item.PedidoMovil}))
                                                    .reduce((distintas, proformaActual) => {
                                                        if(!distintas.some(x => x.Proforma === proformaActual.Proforma)) {
                                                            distintas.push(proformaActual)
                                                        }
                                                        return distintas;
                                                    }, []);

    return proformasEncartonadas.map(prof => ({ id: prof.Proforma,
                                                pedidoMovil: prof.PedidoMovil,
                                                idCliente: encartonado.cli.Codigo,
                                                nombreCliente: encartonado.cli.Nombre,
                                                tipo: prof.TipoProf==='B'? 'STOCK': (prof.TipoProf==='T'? 'TRÁNSITO':'DESCONOCIDO'),
                                                esEncartonada: true}));
}

export const anularEncartonado = (idEncartonado, idRegistroAuditoria, callback) => {
    return (dispatch) => {
        dispatch({
            type: VISUALIZAR_LOADING,
            isVisibleLoading: true
        });

        return global_axios({
            method: 'DELETE',
            url: `/encartonados/${idEncartonado}`,
            headers: {idregaudit: idRegistroAuditoria}
        })
        .then(() => {
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });

            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'info',
                    titulo: 'Encartonado anulado',
                    mensaje: `Se anuló exitosamente el Encartonado: ${idEncartonado}`
                }
            });

            if (callback && typeof(callback) === 'function') {
                callback();
            }
        })
        .catch(error => {
            let msgError = error.response ? error.response.data.msg : error.message;
            dispatch({
                type: VISUALIZAR_LOADING,
                isVisibleLoading: false
            });
            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {
                    isVisible: true,
                    tipo: 'error',
                    titulo: 'Error al anular el Encartonado',
                    mensaje: msgError
                }
            });
        });
    }
}

export const setEncartonadoId = (encartonadoId) => {
    return {type: SET_ENCARTONADO_ID, encartonadoId};
}

export const setEncartonadoObservacion = (observacion) => {
    return {type: SET_ENCARTONADO_OBSERVACION, observacion};
}

export const setEncartonadoFecha = (fecha) => {
    return {type: SET_ENCARTONADO_FECHA, fecha};
}